// extracted by mini-css-extract-plugin
export default {"loginForm":"style_loginForm__HlSb0","loginBody":"style_loginBody__ncGcL"};